import { Component, OnInit, HostListener, AfterViewInit, ChangeDetectorRef } from "@angular/core";
import { ProductBody, ProductAttributes, SpecificationData } from "@models/product.model";
import { ActivatedRoute, Router } from "@angular/router";
import { finalize } from "rxjs";
import { ReviewAttributes } from "@models/review.model";
import { Location } from "@angular/common";
import { ProductService } from "../../services/product/product.service";
import { environment } from "~/src/environments/environment";
import { GenericDialogComponent } from "../../shared/generic-dialog/generic-dialog.component";
import { MatDialog } from "@angular/material/dialog";
import { DialogInvokingComponents } from "@models/generic-dialog.model";

@Component({
    selector: "app-product-review-page",
    templateUrl: "./product-review-page.component.html",
    styleUrl: "./product-review-page.component.scss",
    standalone: false,
})
export class ProductReviewPageComponent {
    public productId!: number;
    public productDetail!: ProductAttributes;
    public showReadMore = false;
    public data: ProductBody[] = [];
    public reviews: ReviewAttributes[] = [];
    public totalBlocks!: number;
    public loading: boolean = true;
    public pageIndex = 0;
    public pageSize = 5;
    public initialPageSize = 10;
    public totalcount = 0;
    public distribution: any;
    public distributionEntries: any;

    public specifications = SpecificationData;
    constructor(
        private productService: ProductService,
        private route: ActivatedRoute,
        private router: Router,
        private cdr: ChangeDetectorRef,
        public location: Location,
        private dialog: MatDialog,
    ) {}

    ngOnInit(): void {
        this.route.params.subscribe((params) => {
            this.productId = +params["id"];
        });
        if (this.productId) {
            this.loadProducts();
            this.loadReviews(this.initialPageSize);
            this.loadReviewDistribution();
        }
    }

    private loadProducts(): void {
        this.loading = true;
        this.productService
            .getProductById(this.productId)
            .pipe(
                finalize(() => {
                    this.loading = false;
                }),
            )
            .subscribe((product) => {
                if (!product) {
                    return;
                }
                this.productDetail = product;
            });
    }

    private loadReviews(pageSize: number = environment.dynamicPagination.pageSize): void {
        this.loading = true;
        this.productService.getAllReviews(this.productId, this.pageIndex, pageSize).subscribe({
            next: (response) => {
                this.loading = false;
                this.reviews = [...this.reviews, ...response.rows];
                this.totalcount = response.count;
            },
            error: () => {
                this.loading = false;
            },
        });
    }

    public goToHome(): void {
        this.router.navigate(["/"]);
    }

    public loadReviewDistribution(): void {
        this.productService.getReviewsDistribution(this.productId).subscribe((response) => {
            this.distribution = response;
            this.distributionEntries = Object.entries(this.distribution);
        });
    }

    public onViewMoreClick(): void {
        this.pageIndex > 1 ? this.pageIndex++ : (this.pageIndex = 2);
        this.loadReviews(this.pageSize);
    }

    public goBack(): void {
        this.location.back();
    }

    public onClickImage(imagesUrl: string[]): void {
        const imageObject = imagesUrl.map((url) => ({ image: url, thumbImage: url }));
        this.dialog.open(GenericDialogComponent, {
            data: { imageSlider: imageObject, componentName: DialogInvokingComponents.ImageSlider },
        });
    }
}
